import { ButtonHTMLAttributes, ElementType } from "react";

interface SignUpPassValidationProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    icon: ElementType,
    text: string,
    validation: boolean
}

export function SignUpPassValidation({ icon: Icon, text, validation }: SignUpPassValidationProps) {
    return (
        <div className="tw-flex tw-flex-row ">
            <div className="tw-leading-3 -tw-mt-1 tw-w-8">
                <Icon style={{ color: validation ? '#ED636E' : '', display: validation ? 'block' : 'none' }} />
            </div>
            
            <span className={validation ? 'tw-leading-5 tw-line-through tw-text-lg' : 'tw-leading-5 tw-text-lg'} >
                {text}
            </span>
        </div >
    )
}